import { render, staticRenderFns } from "./hotBrand524.vue?vue&type=template&id=a980256a&scoped=true"
import script from "./hotBrand524.vue?vue&type=script&lang=js"
export * from "./hotBrand524.vue?vue&type=script&lang=js"
import style0 from "./hotBrand524.vue?vue&type=style&index=0&id=a980256a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a980256a",
  null
  
)

export default component.exports